
export const MAIN_CONSTANT = {
    GOOGLE_MAPS_API_KEY_GOES_HERE: 'AIzaSyDfe6vA05CMu2J1pzTErIVRDm7FlH08D5M'
};